import { QueryFunction, QueryKey, useQuery as useRQQuery, UseQueryResult } from 'react-query';
import { useCallback } from 'react';
import { stringify } from 'qs';

import { useClient } from '@percent/hosted-validation-form/hooks/useClient/useClient';

import { QueryFn, UseQueryOptions } from './useQuery.types';

export const useQuery = <TArgs = unknown, TParams = unknown, TError = unknown, TResponse = TParams>(
  queryKey: QueryKey,
  query: QueryFn<TArgs, TParams, TResponse>,
  options?: UseQueryOptions<TArgs, TParams, TError, TResponse>,
): UseQueryResult<TResponse, TError> => {
  const client = useClient();

  const { endpoint, args } = query(options?.args);

  const queryFn: QueryFunction<TParams> = useCallback(() => {
    return client.get(`${endpoint}${args ? `?${stringify(args, { addQueryPrefix: false })}` : ''}`);
  }, [args, client, endpoint]);

  return useRQQuery<TParams, TError, TResponse, QueryKey>(queryKey, queryFn, options);
};
